import { render, staticRenderFns } from "./DefaultError.vue?vue&type=template&id=81fc7818"
import script from "./DefaultError.vue?vue&type=script&lang=js"
export * from "./DefaultError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports